var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPeace = function SvgIconPeace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m9-7.938a8 8 0 0 0-6.075 11.676L11 11.48zm2 0v7.418l6.075 4.258A8.001 8.001 0 0 0 13 4.062m4.925 13.313L13 13.922v6.016a7.98 7.98 0 0 0 4.925-2.563M11 19.938v-6.016l-4.925 3.453A7.98 7.98 0 0 0 11 19.938",
    clipRule: "evenodd"
  })));
};
export default SvgIconPeace;